import { ClientCategoryNodeWrapper } from '@/components/server-category-tree/_components/server-category-tree-display/_components/client-category-node-wrapper'; // Исправленный путь (два уровня вверх)
import { TMaterialsTreeCategoryItem } from '@/api/get-materials-tree/_types';
import { ClientMaterialLinkButton } from './_components/client-material-link-button';

type TProps = {
  category: TMaterialsTreeCategoryItem;
  parentCategoryTitle: string;
  parentDict: Record<string, string>;
};

export const ServerCategorySectionButton = ({
  category,
  parentCategoryTitle,
  parentDict,
}: TProps) => {
  const articleList = category.articles;

  const hasArticles = articleList.length > 0;

  const articlesContent = hasArticles ? (
    <>
      {articleList.map((item) => (
        <ClientMaterialLinkButton
          key={`${category.id}_${item.id}`}
          category={category}
          material={item}
          parentCategoryTitle={parentCategoryTitle}
        />
      ))}
    </>
  ) : null;

  return (
    <div data-testid={`server-category-section-button-${category.id}`}>
      <ClientCategoryNodeWrapper
        category={category}
        elementType="section"
        isExpandable={hasArticles}
        parentCategoryTitle={parentCategoryTitle}
        parentDict={parentDict}
      >
        {articlesContent}
      </ClientCategoryNodeWrapper>
    </div>
  );
};
